import $ = require('jquery');
import l10n from 'diy/util/l10n';
import DragSource = require('diy/common/js/dd/DragSource');
import DropZone = require('diy/common/js/dd/DropZone');
import MatrixDropZone = require('./MatrixDropZone');

declare var Hammer: any;
type Hammer = any;
type HammerEvent = any;

/**
 * @depends moduleSelector.js
 * @depends ui.moduleDraggable.js
 */
    let triggerFakeTouchEvent = function(event: JQueryEventObject, target: any, eventType: string) {
        let offset = $(target).offset();
        let newevent = $.Event(eventType);
        newevent.which = 1;
        newevent.target = target;
        newevent.pageX = event.pageX ? event.pageX : offset.left;
        newevent.pageY = event.pageY ? event.pageX : offset.top;
        newevent.originalEvent = event;

        $(target).trigger(newevent);
    };

    class ModuleDragSource extends DragSource {
        protected static draggableWidgetName = 'moduleDraggable';
        protected dragMode: string;

        public webcomponentId: string;
        protected maxInstancesPerPage: string;
        protected moduleMinWidth: number;

        protected matrixId: number;
        protected allowedInSidebar: boolean;

        private hammerInst: Hammer;
        private hammerHandler: (this: HTMLElement, e: HammerEvent) => void;

        constructor(element: JQuery) {
            super(element);

            if (diy.editor.uiPreference.isPointerModeTouch()) {
                this._toggleDraggableDisabledState(true);

                this.hammerInst = new Hammer(element.get(0), {
                    hold: true,
                    hold_threshold: 50,
                    stop_browser_behavior: {}
                });

                let self = this;
                this.hammerHandler = function (e) {
                    let event = e.gesture.srcEvent;
                    // Enable the draggable and simulate a drag start
                    self._toggleDraggableDisabledState(false);

                    triggerFakeTouchEvent(event, this, 'touchstart');
                    triggerFakeTouchEvent(event, this, 'touchmove');
                };

                this.hammerInst.on('hold', this.hammerHandler);
                element.addClass('disable-touch-defaults');

                this.element.on('touchcancel', function(event) {
                    $('body').one('touchstart', function() {
                        triggerFakeTouchEvent(event, self.element, 'mouseup');
                    });
                });
            }
        }

        getDraggableWidgetName() {
            return ModuleDragSource.draggableWidgetName;
        }

        _toggleDraggableDisabledState(disabled: boolean) {
            disabled = !!disabled;

            // Disable the draggable because we will trigger it programatically
            // after catching the press&hold event
            this.element[this.getDraggableWidgetName()]('option', 'disabled', disabled);
            // HACK: Disabling the widget also adds this unwanted class so we have
            // to get rid of it manually.
            if (disabled) {
                this.element.removeClass('ui-state-disabled');
            }
        }

        destroy() {
            if (diy.editor.uiPreference.isPointerModeTouch()) {
                this.element.removeClass('disable-touch-defaults');
                this.hammerInst.off('hold', this.hammerHandler);
                this.hammerHandler = null;
                this.hammerInst = null;
            }
            super.destroy();
        }

        init() {
            super.init();

            this.setDraggableOptions({
                connectToSortable: "div.sortable-matrix",
                scroll: !diy.editor.uiPreference.isPointerModeTouch()
            });

            if (diy.editor.uiPreference.isPointerModeTouch()) {
                // On touch device we simulate touchstart/touchmove from a press&hold event
                // so it is necessary to set these values
                this.setDraggableOptions({
                    distance: 0,
                    delay: 0
                });
            }
        }

        onDragStop(e: Event, ui: {}) {
            super.onDragStop(e, ui);
            if (diy.editor.uiPreference.isPointerModeTouch()) {
                // Disable the draggable again after a drag
                this._toggleDraggableDisabledState(true);
            }
        }

        moduleReachedMaxInstancesPerPage(pageId: number, matrixId: number, reachedInPages: number[]) {
            reachedInPages = reachedInPages || [];
            if (this.maxInstancesPerPage === undefined || this.webcomponentId === undefined) {
                return false;
            } else {
                let pages = jimdoData.navigation.pages;
                let pagesWithMatrix: typeof pages = [];
                for (let i = 0; i < pages.length; i++) {
                    /* tslint:disable:triple-equals */
                    if (
                        // the page contain drop matrix
                        pages[i].matrixes[matrixId] !== undefined
                        // ignore hidden pages except current page
                        && !(pages[i].hidden && pages[i].pageId != pageId)
                    ) {
                        pagesWithMatrix.push(pages[i]);
                    }
                    /* tslint:enable:triple-equals */
                }
                // validate each page didn't reach the limit
                let wpm = jimdoData.webcomponentsPerMatrix;
                for (let i = 0; i < pagesWithMatrix.length; i++) {
                    let count = 0;
                    let pMatrixes = pagesWithMatrix[i].matrixes;
                    for (let pMatrixId in pMatrixes) {
                        // skip too narrow matrixes from counting
                        // because there this type of webcomponent is not rendered
                        if (pMatrixes[pMatrixId].width < this.moduleMinWidth) {
                            continue;
                        }

                        if (wpm[pMatrixId] && wpm[pMatrixId][this.webcomponentId]) {
                            count += parseInt(<string><any>wpm[pMatrixId][this.webcomponentId], 10);
                        }
                        // if this module is in this matrix, exclude it from counting
                        // but only if it will be moved
                        /* tslint:disable:triple-equals */
                        if (this.matrixId && this.matrixId == parseInt(pMatrixId, 10) &&
                            this.dragMode !== 'duplicate') {
                            count--;
                        }
                        /* tslint:enable:triple-equals */
                    }
                    if (count >= parseInt(<string><any>this.maxInstancesPerPage, 10)) {
                        reachedInPages.push(pagesWithMatrix[i].pageId);
                    }
                }

                return reachedInPages.length > 0;
            }
        }

        moduleFitsInMatrix(pageId: number, matrixId: number) {
            if (isNaN(this.moduleMinWidth) || null == this.moduleMinWidth) {
                return true;
            }
            let pages = jimdoData.navigation.pages;
            let matrixWidth: number;
            for (let i = 0; i < pages.length; i++) {
                /* tslint:disable:triple-equals */
                if (pages[i].pageId == pageId) {
                    matrixWidth = pages[i].matrixes[matrixId].width;
                    if (isNaN(matrixWidth) || null == matrixWidth) {
                        return true;
                    }
                    return matrixWidth >= this.moduleMinWidth;
                }
                /* tslint:enable:triple-equals */
            }
            // no matching pageId/matrixId
            return false;
        }

        moduleAllowedInMatrix(pageId: number, matrixId: number) {
            if (this.allowedInSidebar) {
                return true;
            }

            let pages = jimdoData.navigation.pages;
            for (let i = 0; i < pages.length; i++) {
                /* tslint:disable:triple-equals */
                if (pages[i].pageId == pageId) {
                    let isSidebar = pages[i].matrixes[matrixId].isSidebar;
                    if (isSidebar && !this.allowedInSidebar) {
                        return false;
                    }
                }
                /* tslint:enable:triple-equals */
            }

            return true;
        }

        canBeDropped(dropZone: MatrixDropZone): boolean|string {
            if (!dropZone) {
                return false;
            }
            let pageId = dropZone.getPageId();
            let matrixId = dropZone.getMatrixId();
            let reachedInPages: number[] = [];
            if (this.moduleReachedMaxInstancesPerPage(pageId, matrixId, reachedInPages)) {
                if (reachedInPages.indexOf(pageId) !== -1) {
                    return this.getErrorMessage('module_singleton_in_page', dropZone);
                } else {
                    return this.getErrorMessage('module_singleton_in_other_pages', dropZone);
                }
            }
            if (!this.moduleAllowedInMatrix(pageId, matrixId)) {
                return this.getErrorMessage('module_not_allowed_sidebar', dropZone);
            }
            if (!this.moduleFitsInMatrix(pageId, matrixId)) {
                return this.getErrorMessage('module_too_wide', dropZone);
            }
            return true;
        }

        getErrorMessage(error: string, dropZone: DropZone) {
            if (error === 'module_singleton_in_page') {
                return l10n('moduleSelector.restrictedAllSingletonAreaToolTip');
            }
            if (error === 'module_singleton_in_other_pages') {
                return l10n('moduleSelector.restrictedSidebarSingletonAreaToolTip');
            }
            if (error === 'module_too_wide') {
                return l10n('moduleSelector.restrictedAreaToolTip');
            }
            if (error === 'module_not_allowed_sidebar') {
                return l10n('moduleSelector.moduleNotAllowedSidebar');
            }

            throw new Error(`Unhandled error type ${error}`);
        }

        setModelData() {
            let dataSourceEl = this.getDataSourceEl();
            this.webcomponentId = dataSourceEl.attr('data-webcomponentId');
            this.maxInstancesPerPage = dataSourceEl.attr('data-maxInstancesPerPage');
            this.moduleMinWidth = parseInt(dataSourceEl.attr('data-moduleMinwidth'), 10);
            this.allowedInSidebar = dataSourceEl.attr('data-allowedInSidebar') !== 'false';
        }

        getDataSourceEl() {
            return this.element;
        }

        //abstract
        getLabel() {
            return '';
        }
    }

export = ModuleDragSource;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/ModuleDragSource.ts
 **/